export default __webpack_public_path__ + "static/media/faq-logo.149da247.svg";